import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'avatar' | 'contentType' | 'title' | 'link'>({ name: 'SearchItem' })(
    (_, __, classes) => ({
        item: {
            padding: 20,
            borderRadius: 18,
            background: '#fff',
            marginBottom: 20
        },
        singleItem: {
            padding: 0,
            boxShadow: '0px 10px 40px 0px #C8D4DC59'
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        avatar: {
            marginRight: 16,
            width: 48,
            height: 48,
            border: '1px solid #EDF0F2'
        },
        btnMore: {
            boxShadow: 'none',
            borderRadius: 100,
            fontSize: 14,
            transition: 'all 0.2s ease-out',
            background: '#F5F5F5',
            color: '#979797'
        },
        list: {
            borderRadius: 18,
            overflow: 'hidden'
        },
        content: {
            padding: '16px 24px 16px 16px',
            marginBottom: 1,
            marginTop: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start'
        },
        contentType: {
            color: '#8385A3',
            fontSize: 14,
            marginBottom: 8
        },
        contentText: {
            cursor: 'pointer'
        },
        title: {
            fontWeight: 600,
            lineHeight: '25px',
            wordBreak: 'break-all',
            marginBottom: 6
        },
        description: {
            color: '#979797',
            fontSize: 12,
            lineHeight: '17px',
            wordBreak: 'break-all'
        },
        link: {
            textDecoration: 'none',
            color: 'initial'
        },
        chips: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap'
        },
        chip: {
            background: '#F5F5F5',
            borderRadius: 8,
            marginTop: 12,
            marginRight: 8,
            fontSize: 12,
            '& .MuiChip-label': {
                color: '#979797'
            }
        },
        chipIcon: {
            width: 16,
            height: 16
        },
        itemIcon: {
            '@media (max-width: 480px)': {
                display: 'none'
            }
        },
        avatarContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        score: {
            marginTop: 12,
            marginRight: 8
        },
        exactMatchItem: {
            background: '#393939',
            color: '#fafafa',
            [`& .${classes.avatar}`]: {
                background: '#fafafa'
            },
            [`& .${classes.contentType}`]: {
                color: '#fafafa'
            },
            [`& .${classes.title}`]: {
                color: '#fafafa'
            },
            [`& .${classes.link}`]: {
                color: '#fafafa'
            }
        }
    })
);
